import * as RadixSelect from '@radix-ui/react-select';

export const SelectValue = RadixSelect.Value;
